import { CategoryAppsList } from "../components/CategotyAppsList"

export const AppsList: React.FC = () => {
  return (
    <div className="apps-list">
      <CategoryAppsList />
    </div>
  )
}